import { Audience } from 'types/schemaTypes';
import { AudienceStatus, EDITABLE_STATUSES } from 'modules/audiences/constants';

export function canEditAudience({ status }: Pick<Audience, 'status'>): boolean {
  return EDITABLE_STATUSES.includes(status as AudienceStatus);
}

export const notEditableMessage = 'An processing audience cannot be edited.';
